module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('div', [_vm._v("\n  คุณได้เลือก " + _vm._s(_vm.page.title) + " "), (_vm.clearButton) ? _c('a', {
    staticClass: "btn-clear",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear.apply(null, arguments)
      }
    }
  }, [_vm._v("เลือกใหม่")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e40df48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagePreview.vue
// module id = 1117
// module chunks = 0